import Footer from '../../sections/footer/Footer'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import HeaderSolid from '../../sections/header/HeaderSolid'

import './style.scss'
import CtaButton from '../../components/ctaButton/CtaButton'
// import { ROOT_URL } from '../../constants/pathConstants'
import { useState } from 'react'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { loginConnector } from '../../server/connector/loginConnector'
import { useCookies } from 'react-cookie'
import { userStateData } from '../../data/userStateData'
import { adminStateData } from '../../data/adminStateData'

function AdminLogIn() {

	const [loggingIn, setLoggingIn] = useState<boolean>(false)
	const [email, setEmail] = useState<string>('')
	const [password, setPassword] = useState<string>('')

	const [loginFailed, setLoginFailed] = useState<boolean>(false)

	const [cookies, setCookie] = useCookies(['adminLogin'])

	const loginClicked = () => {
		setLoggingIn(true)
		loginConnector.performAdminLoginRequest(email, password).then((successRequest) => {
			if (!successRequest) {
				setLoginFailed(true)
				setLoggingIn(false)
			} else {
				userStateData.loggedIn = true
				setCookie("adminLogin", adminStateData.loggedIn, {
					path: "/"
				})
				window.location.replace(PAGE_URLS.ADMIN)
			}
		})
	}
	
	return (
		<>
			<div className='section-wrap section-seperator'>
				<HeaderSolid />
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<div className='sign-up-content'>
						<div className='sign-up-content-section'>
							<div className='sign-up-form'>
								<div className='sign-up-form-title'>ADMIN - Log In</div>
								<input 
									className='sign-up-form-input' 
									type={'email'} 
									placeholder={'Email Address *'} 
									value={email}
									onChange={(event) => {
										setEmail(event.target.value)
									}}
									disabled={loggingIn}
								/>
								<input 
									className='sign-up-form-input' 
									type='password'
									placeholder={'Password *'} 
									value={password}
									onChange={(event) => {
										setPassword(event.target.value)
									}}
									disabled={loggingIn}
								/>
								{loginFailed && <div className='sign-up-form-login-failed'>
									Log in Failed, please check email and password and try again
								</div>}
								<CtaButton
									label={loggingIn ? 'Logging In...' : 'Log In'}
									size='medium'
									onClick={() => loginClicked()}
									fullWidth={true}
									disabled={
										email === '' ||
										password === '' ||
										loggingIn
									}
								/>
							</div>
						</div>
						<div className='sign-up-content-section log-in-picture-section'>
							<img
								className='sign-up-picture'
								alt='Ski Lift'
								src='/imgs/pictures/ski-lift.png'
							/>
						</div>
					</div>
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<Footer />
				</div>
			</div>
			<BackToTopButton />
		</>
	)
}

export default AdminLogIn
